import type { SVGProps } from 'react';

type EmptyWebhooksIllustrationProps = SVGProps<SVGSVGElement>;

export const EmptyWebhooksIllustration = (
  props: EmptyWebhooksIllustrationProps
) => (
  <svg
    viewBox="0 0 99 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M49.5 99C76.8381 99 99 76.8381 99 49.5C99 22.1619 76.8381 0 49.5 0C22.1619 0 0 22.1619 0 49.5C0 76.8381 22.1619 99 49.5 99Z"
      fill="var(--tenant-surface-selected)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.5654 41.2161C29.5657 30.4272 38.312 21.6812 49.101 21.6812C59.8901 21.6812 68.6365 30.4275 68.6365 41.2167L68.6359 41.359V43.3873C68.6359 49.532 70.9542 55.13 74.7673 59.3627C75.2492 59.8976 75.4345 60.6366 75.262 61.3356C75.0896 62.0345 74.5817 62.6025 73.9064 62.8518C69.4378 64.5015 64.7599 65.7182 59.924 66.4514C59.9439 66.7199 59.954 66.9909 59.954 67.2641C59.954 73.2581 55.0949 78.1171 49.101 78.1171C43.107 78.1171 38.2479 73.2581 38.2479 67.2641C38.2479 66.991 38.258 66.72 38.2779 66.4515C33.4416 65.7184 28.7633 64.5016 24.2944 62.8518C23.619 62.6025 23.1112 62.0345 22.9387 61.3356C22.7663 60.6366 22.9516 59.8976 23.4334 59.3627C27.2466 55.1301 29.5649 49.532 29.5649 43.3873L29.5654 41.2161ZM42.5955 66.9725C42.5913 67.0691 42.5891 67.1663 42.5891 67.2641C42.5891 70.8605 45.5046 73.7759 49.101 73.7759C52.6974 73.7759 55.6128 70.8605 55.6128 67.2641C55.6128 67.1663 55.6107 67.069 55.6064 66.9724C53.4631 67.1655 51.293 67.2641 49.1004 67.2641C46.9082 67.2641 44.7385 67.1655 42.5955 66.9725Z"
      fill="white"
    />
    <rect
      x="53.4917"
      y="13.5728"
      width="27.1452"
      height="27.1452"
      rx="13.5726"
      fill="var(--tenant-content-positive-soft)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.4756 27.1457C61.4756 26.815 61.7437 26.5469 62.0744 26.5469L70.5676 26.5469L67.2481 23.3858C67.0097 23.1566 67.0022 22.7775 67.2315 22.5392C67.4607 22.3008 67.8397 22.2933 68.0781 22.5226L72.4692 26.7141C72.5867 26.827 72.653 26.9828 72.653 27.1457C72.653 27.3086 72.5867 27.4644 72.4692 27.5773L68.0781 31.7689C67.8397 31.9981 67.4607 31.9907 67.2315 31.7523C67.0022 31.5139 67.0097 31.1348 67.2481 30.9056L70.5676 27.7445L62.0744 27.7445C61.7437 27.7445 61.4756 27.4764 61.4756 27.1457Z"
      fill="white"
      stroke="white"
      strokeWidth="0.798387"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
